export function getSimpleHashByString(source: string): number {
    let result = 0;
    for (let index = 0; index < source.length; index++) {
        result = ((result << 5) - result + source.charCodeAt(index)) | 0;
    }
    return result;
}
